import { useCallback, useEffect, useState } from "react";
import Vehicle from "../passapp-sdk/vehicle";
import { useStore } from "./useStore";
import { SelectOption } from "../components/common/PL/Select/Select";

const vehicleApi = new Vehicle();

/** Aseguradoras dadas de alta por el admin de edificios. Mismo patrón que useVehicleBrands, pero
 * la respuesta trae `{id, name}` así que el value es el id (las marcas no tienen id). */
const useInsuranceCompanies = () => {
  const { authStore } = useStore();
  const [companies, setCompanies] = useState<SelectOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCompanies = useCallback(
    async (search?: string) => {
      if (!authStore.token) return;
      setLoading(true);
      try {
        const response = await vehicleApi.getInsuranceCompanies(authStore.token, search);
        if (response?.data) {
          const companiesArray = Array.isArray(response.data)
            ? response.data
            : Object.values(response.data);
          const options: SelectOption[] = companiesArray.map((company: any) => ({
            value: company.id,
            label: company.name,
          }));
          setCompanies(options);
        }
      } catch (err) {
        console.error("Error fetching insurance companies:", err);
      } finally {
        setLoading(false);
      }
    },
    [authStore.token]
  );

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  return { companies, loading, fetchCompanies };
};

export default useInsuranceCompanies;
